/*
  Project: Bnppblog
  Author: Michał Strześniewski
 */

import clipboard from './modules/clipboard';
import selectCat from './modules/selectCat';
import menu from './modules/menu';
import scrollTop from './modules/scrollTop';
import popup from './modules/popup';
import slider from './modules/slider';
import pagination from './modules/pagination';
import calendarEvents from './modules/calendarEvents';

clipboard();
selectCat();
menu();
scrollTop();
popup();
slider();
pagination();
calendarEvents();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/app.js